<template>
    <div style="margin:0 auto;width:300px;">
        <img src="../../../assets/OnBoardingQRCode.png" style="width:300px;height:300px"/>
        <Button style="margin-left: 90px" @click="jumpPage">填写入职信息</Button>
    </div>
</template>

<script>
  export default {
    created() {
    },
    methods:{
        jumpPage(){
          window.open('http://122.9.5.81:9005/#/S6SF1RC2F6B81FD7E97BFC316C981F88C/56782NHW845FR43M');
        }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/process/MyManagement/OnBoardingQRCode.vue